import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./index.css";
import parse from "html-react-parser";

export default function PowerofAngelAi({angelAiLink, sunwestLink1}) {
    const imgCDNURL = process.env.REACT_APP_CDN + "eaimortgage/images/";
    return (
        <section className="powerofangelai">
            <Container>
                <Row className='powerofangelai-row'>
                    <Col sm={12} md={12} lg={5}>
                        <img
                            src={imgCDNURL + "human-touch.webp"}
                            alt="AngelAi with the Human Touch"
                            className="powerofangelai-img"
                            width={"100%"}
                            height={"auto"}
                        />
                    </Col>
                    <Col sm={12} md={12} lg={7} className="powerofangelai-text">
                        <h2 className="powerofangelai-heading">
                            Combine the Power of {parse(angelAiLink)}<br /> with the Human Touch
                        </h2>
                        <p className="powerofangelai-subheading">
                            For a Fast, Stress-Free Mortgage Journey
                        </p>
                        <p className="powerofangelai-para">
                            Gone are the days of a slow and clunky mortgage process. With {parse(angelAiLink)} you’ll experience an On-Demand loan approval in minutes to hours, what traditionally took days and weeks. Her answers are 100% Trusted and backed by {parse(sunwestLink1)} so you can rest easy while you find the home of your dreams. {parse(angelAiLink)} is available 24/7 to assist and your loan officer is also available to guide you every step of the way.
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
